import { useFormikContext } from 'formik';
import fileDownload from 'js-file-download';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { IRuleGeneric } from '../../backend';
import { RoundButton } from '../Button/RoundButton/RoundButton';

export const RuleEditorExportButton = memo(function RuleEditorExportButton({ fileName }: { fileName?: string }) {
    const { values } = useFormikContext<IRuleGeneric>();
    const handleExportJson = (values: IRuleGeneric) =>
        fileDownload(JSON.stringify(values, null, 2), fileName || `${values.name || values.type}.json`);

    return (
        <RoundButton color="primary" size="medium" onClick={() => handleExportJson(values)} variant="outlined">
            <FormattedMessage id={'ruleEditor.editor.exportjson'} />
        </RoundButton>
    );
});
